import { render, staticRenderFns } from "./QuaisDatas.vue?vue&type=template&id=074a2bd1"
import script from "./QuaisDatas.vue?vue&type=script&lang=js"
export * from "./QuaisDatas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports